import React from 'react';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[400px] flex flex-col items-center justify-center text-center p-8">
          <AlertTriangle className="w-10 h-10 text-[#A67C52] mb-4" />
          <h2 className="font-serif text-[24px] text-[#1C1C1C] font-medium mb-2">Something went wrong</h2>
          <p className="text-[14px] text-[#8C877F] font-sans mb-4 max-w-md">An unexpected error occurred. Please try refreshing the page.</p>
          <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            className="bg-[#1F3A34] text-white hover:bg-[#285047] rounded-lg text-[13px] px-6 py-2.5 font-sans font-medium">
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
